import axios from 'axios';
import store from '@/store/index';
import router from '@/router';


export default class {
  constructor() {
    this.headers = {};
    if (store.state.user.isLoggedIn) {
      this.headers.Authorization = `Bearer ${store.state.user.accessToken}`;
    }
    this.data = {};
    this.baseURL = process.env.VUE_APP_API_URL;
    this.headers['X-Requested-With'] = 'XMLHttpRequest';
    this.headers.Accept = 'appllication/json';
    this.headers['Content-Type'] = 'appllication/json';
    this.maxRedirects = 5;
    this.validateAuth = true;
    this.CancelToken = axios.CancelToken;
    this.source = this.CancelToken.source();
    this.params = {};
    this.responseType = null;
    return this;
  }

  submitRequest() {
    return new Promise((resolve, reject) => {
      if (this.baseURL === process.env.VUE_APP_API_BLMS_URL) {
        this.headers.Authorization = `Bearer ${store.state.user.blmsAccessToken}`;
      }

      let payload = {
        method: this.method,
        url: this.url,
        data: this.data,
        headers: this.headers,
        baseURL: this.baseURL,
        maxRedirects: this.maxRedirects,
        params: this.params,
        cancelToken: this.source.token,
      }

      if (this.responseType !== null) {
        payload = Object.assign(payload, {
          responseType: this.responseType
        })
      }

      axios(payload).then((response) => {
        resolve(response); 
      })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401 && store.state.user.isLoggedIn
               && this.validateAuth && error.response.data.error.code !== 'INVALID_CREDENTIALS') {
              this.refreshAccessToken(resolve);
            } else if (
              error.response.status === 401
              && !store.state.user.isLoggedIn
              && this.validateAuth
            ) {
              localStorage.clear();
              router.push('/login');
            } else {
              reject(error);
            }
          } else if (error.request) {
            reject(error);
          }
        });
    });
  }

  cancelPreviousRequest() {
    this.source.cancel();
  }

  refreshAccessToken(resolve) {
    const headers = {};
    headers['X-Requested-With'] = 'XMLHttpRequest';
    headers.Accept = 'appllication/json';
    headers['Content-Type'] = 'appllication/json';
    headers.Authorization = `Bearer ${store.state.user.refreshToken}`;
    axios({
      method: 'POST',
      url: `${this.baseURL}/refresh-token`,
      data: {},
      headers,
      baseURL: this.baseURL,
    }).then((response) => {
      // set locals
      localStorage.setItem('accessToken', response.data.token.access_token);
      localStorage.setItem('refreshToken', response.data.token.refresh_token);
      // set store
      store.dispatch({
        type: 'user/updateAccessToken',
        accessToken: response.data.token.access_token,
      });
      store.dispatch({
        type: 'user/updateRefreshToken',
        refreshToken: response.data.token.refresh_token,
      });
      store.dispatch({ type: 'user/updateIsLoggedIn', isLoggedIn: true });
      this.headers.Authorization = `Bearer ${store.state.user.accessToken}`;
      axios({
        method: this.method,
        url: this.url,
        data: this.data,
        headers: this.headers,
        baseURL: this.baseURL,
        maxRedirects: this.maxRedirects,
        params: this.params,
        cancelToken: this.source.token,
      }).then((response1) => {
        resolve(response1);
      });
    }).catch(() => {
      localStorage.clear();
      router.push('/login');
    });
  }
}
